import {
  StoriesContextProvider,
  StoriesContextProviderProps,
} from "@/components/builder/stories/list/stories-context-provider";
import { withChildren } from "@builder.io/react";

function StoriesGroup(props: StoriesContextProviderProps) {
  return (
    <div>
      {!props.children && <div>Please add children components to the stories group</div>}

      <StoriesContextProvider {...props}>{props.children}</StoriesContextProvider>
    </div>
  );
}

export const StoriesGroupWithChildren = withChildren(StoriesGroup);
